// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__zEYeJ","total":"MasterSaleDetails_total__pZSc3","edit":"MasterSaleDetails_edit__aQRkH","cancel":"MasterSaleDetails_cancel__jyvVm"};